(function () {
  var MAX_COMPARE = 3;
  var ORDINAL = ['1st', '2nd', '3rd'];
  var SPEC_FIELDS = [
    { key: 'gender', label: 'Gender' },
    { key: 'sleeping_bag_comfort', label: 'Sleeping Bag Comfort' },
    { key: 'maximum_volume', label: 'Maximum Volume', suffix: ' L' },
    { key: 'fits', label: 'Fits' },
    { key: 'sleeping_capacity', label: 'Sleeping Capacity' },
    { key: 'external_dimensions', label: 'External Dimensions', suffix: ' mm' },
    { key: 'sleeping_area', label: 'Sleeping Area', suffix: ' mm' },
    { key: 'packed_dimensions', label: 'Packed Dimensions', suffix: ' mm' },
    { key: 'rated_capacity', label: 'Rated Capacity', suffix: ' kg' },
    { key: 'coverage', label: 'Coverage' },
    { key: 'internal_storage_and_bedding', label: 'Internal Storage and Bedding' },
    { key: 'valve_quantity', label: 'Valve Quantity' },
    { key: 'internal_dimensions', label: 'Internal Dimensions', suffix: ' mm' },
    { key: 'suits_product', label: 'Suits Product' },
    { key: 'weight', label: 'Weight', suffix: ' kg' },
    { key: 'warranty', label: 'Warranty' }
  ];

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseCompareData(trigger) {
    var raw = trigger.getAttribute('data-compare');
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      console.warn('Unable to parse compare data', error);
      return null;
    }
  }

  function normalizeCompareItem(data) {
    if (!data || !data.productId) return null;

    var item = Object.assign({}, data);
    var variants = Array.isArray(item.variants) ? item.variants.slice() : [];

    if (!variants.length && item.specs) {
      variants = [
        {
          id: item.productId,
          title: 'Default Title',
          price: item.productPrice,
          image: item.productImage,
          url: item.productUrl,
          specs: item.specs
        }
      ];
    }

    item.variants = variants;
    item.selectedVariantId =
      item.selectedVariantId || (variants[0] && variants[0].id) || null;

    return item;
  }

  function getItemVariants(item) {
    return (item && item.variants) || [];
  }

  function getSelectedVariant(item) {
    var variants = getItemVariants(item);
    if (!variants.length) return null;

    var selectedId = item.selectedVariantId;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(selectedId)) {
        return variants[i];
      }
    }

    return variants[0];
  }

  function hasSpecValue(value) {
    if (Array.isArray(value)) return value.some(Boolean);
    return value != null && String(value).trim() !== '';
  }

  function formatSpecValue(value, suffix) {
    if (Array.isArray(value)) {
      var list = value.filter(Boolean);
      return list.length ? list.join(', ') : '';
    }

    if (!hasSpecValue(value)) return '';
    return String(value) + (suffix || '');
  }

  function getCustomSpecValue(item, label) {
    var specs = item.specifications || [];
    for (var i = 0; i < specs.length; i++) {
      if (specs[i] && specs[i].label === label) {
        return specs[i].value || '';
      }
    }
    return '';
  }

  function buildSpecRows(items) {
    var rows = [];
    var seenLabels = {};

    items.forEach(function (item) {
      (item.specifications || []).forEach(function (spec) {
        if (!spec || !spec.label || seenLabels[spec.label]) return;
        seenLabels[spec.label] = true;
        rows.push({
          type: 'custom',
          label: spec.label
        });
      });
    });

    SPEC_FIELDS.forEach(function (field) {
      var anyHasValue = items.some(function (item) {
        return getItemVariants(item).some(function (variant) {
          return hasSpecValue(variant.specs && variant.specs[field.key]);
        });
      });

      if (!anyHasValue) return;

      rows.push({
        type: 'darche',
        key: field.key,
        label: field.label,
        suffix: field.suffix || ''
      });
    });

    return rows;
  }

  function getRowValue(item, row) {
    if (row.type === 'custom') {
      return getCustomSpecValue(item, row.label);
    }

    var variant = getSelectedVariant(item);
    return formatSpecValue(variant && variant.specs && variant.specs[row.key], row.suffix);
  }

  function shouldShowVariantSelect(item) {
    var variants = getItemVariants(item);
    if (variants.length < 2) return false;
    if (item.hasOnlyDefaultVariant) return false;
    return true;
  }

  function initComparePanel(panel) {
    var slotsEl = panel.querySelector('[data-compare-slots]');
    var compareBtn = panel.querySelector('[data-compare-action="compare"]');
    var clearBtn = panel.querySelector('[data-compare-action="clear"]');
    var modal = document.querySelector('[data-compare-modal]');
    var modalGrid = modal ? modal.querySelector('[data-compare-modal-grid]') : null;
    var items = [];

    function getCheckboxByProductId(productId) {
      return document.querySelector(
        '.darche-compare-trigger[data-product-id="' + productId + '"] input[type="checkbox"]'
      );
    }

    function emptySlotMarkup(index) {
      return `
        <div class="darche-compare__slot darche-compare__slot--empty" data-compare-slot="${index}">
          <p class="darche-compare__slot-placeholder">Add ${ORDINAL[index]} product to compare</p>
        </div>
      `;
    }

    function filledSlotMarkup(item, index) {
      var variant = getSelectedVariant(item);
      var title = escapeHtml(item.productTitle);
      var image = escapeHtml((variant && variant.image) || item.productImage);
      var productId = escapeHtml(item.productId);
      var price = escapeHtml((variant && variant.price) || item.productPrice);
      var imageMarkup = image
        ? `<img src="${image}" alt="${title}" width="80" height="80" loading="lazy">`
        : '';

      return `
        <div class="darche-compare__slot darche-compare__slot--filled" data-compare-slot="${index}" data-product-id="${productId}">
          <div class="darche-compare__slot-media">
            ${imageMarkup}
          </div>
          <div class="darche-compare__slot-body">
            <p class="darche-compare__slot-title">${title}</p>
            <div class="darche-compare__slot-meta">
              <span class="darche-compare__slot-price">${price}</span>
              <button type="button" class="darche-compare__slot-remove" data-compare-remove="${productId}">Remove</button>
            </div>
          </div>
        </div>
      `;
    }

    function variantSelectMarkup(item, columnIndex) {
      if (!shouldShowVariantSelect(item)) return '';

      var variants = getItemVariants(item);
      var selected = getSelectedVariant(item);
      var options = variants
        .map(function (variant) {
          var selectedAttr =
            selected && String(selected.id) === String(variant.id) ? ' selected' : '';
          return `<option value="${escapeHtml(variant.id)}"${selectedAttr}>${escapeHtml(
            variant.title
          )}</option>`;
        })
        .join('');

      return `
        <label class="darche-compare-modal__variant">
          <span class="visually-hidden">Select variant</span>
          <select
            class="darche-compare-modal__variant-select"
            data-compare-variant-select
            data-product-id="${escapeHtml(item.productId)}"
            data-column-index="${columnIndex}"
          >
            ${options}
          </select>
        </label>
      `;
    }

    function productOverviewMarkup(item, columnIndex) {
      var variant = getSelectedVariant(item);
      var title = escapeHtml(item.productTitle);
      var image = escapeHtml((variant && variant.image) || item.productImage);
      var price = escapeHtml((variant && variant.price) || item.productPrice);
      var url = escapeHtml((variant && variant.url) || item.productUrl);
      var imageMarkup = image
        ? `<img src="${image}" alt="${title}" width="400" height="400" loading="lazy">`
        : '';

      return `
        <div class="darche-compare-modal__cell darche-compare-modal__overview" data-compare-column="${columnIndex}">
          <div class="darche-compare-modal__media">
            ${imageMarkup}
          </div>
          <h3 class="darche-compare-modal__title">${title}</h3>
          <div class="darche-compare-modal__price-cta">
            <span class="darche-compare-modal__price">${price}</span>
            <a class="btn btn--primary" href="${url}"><span>Shop now</span></a>
          </div>
          ${variantSelectMarkup(item, columnIndex)}
        </div>
      `;
    }

    function buildModalMarkup(compareItems) {
      var specRows = buildSpecRows(compareItems);
      var productCount = compareItems.length;

      var html = `
        <div class="darche-compare-modal__key darche-compare-modal__key--overview">Overview</div>
        ${compareItems
          .map(function (item, index) {
            return productOverviewMarkup(item, index);
          })
          .join('')}
      `;

      specRows.forEach(function (row) {
        html += `
          <div class="darche-compare-modal__key">${escapeHtml(row.label)}</div>
          ${compareItems
            .map(function (item, index) {
              var value = escapeHtml(getRowValue(item, row));
              return `
                <div
                  class="darche-compare-modal__cell darche-compare-modal__value"
                  data-compare-column="${index}"
                  data-compare-row-type="${escapeHtml(row.type)}"
                  data-compare-row-key="${escapeHtml(row.key || row.label)}"
                >
                  <span class="darche-compare-modal__value-label">${escapeHtml(row.label)}</span>
                  <span class="darche-compare-modal__value-text">${value}</span>
                </div>
              `;
            })
            .join('')}
        `;
      });

      return {
        html: html,
        productCount: productCount
      };
    }

    function openModal() {
      if (!modal || !modalGrid || items.length < 2) return;

      var modalContent = buildModalMarkup(items);
      modalGrid.innerHTML = modalContent.html;
      modalGrid.setAttribute('data-columns', String(modalContent.productCount));
      modalGrid.style.setProperty('--compare-cols', String(modalContent.productCount));

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('darche-compare-modal-open');
    }

    function closeModal() {
      if (!modal) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('darche-compare-modal-open');
    }

    function setSelectedVariant(productId, variantId) {
      var index = findIndexByProductId(productId);
      if (index === -1) return;

      items[index].selectedVariantId = variantId;

      if (modal && modal.classList.contains('is-open')) {
        openModal();
      }

      render();
    }

    function render() {
      if (!slotsEl) return;

      var html = '';
      for (var i = 0; i < MAX_COMPARE; i++) {
        html += items[i] ? filledSlotMarkup(items[i], i) : emptySlotMarkup(i);
      }
      slotsEl.innerHTML = html;

      if (items.length > 0) {
        panel.classList.add('is-visible');
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.classList.remove('is-visible');
        panel.setAttribute('aria-hidden', 'true');
        closeModal();
      }

      if (compareBtn) {
        compareBtn.disabled = items.length < 2;
      }
    }

    function findIndexByProductId(productId) {
      return items.findIndex(function (item) {
        return String(item.productId) === String(productId);
      });
    }

    function addItem(data) {
      var item = normalizeCompareItem(data);
      if (!item) return false;
      if (findIndexByProductId(item.productId) !== -1) return true;
      if (items.length >= MAX_COMPARE) return false;

      items.push(item);
      render();
      return true;
    }

    function removeItem(productId, syncCheckbox) {
      var index = findIndexByProductId(productId);
      if (index === -1) return;

      items.splice(index, 1);
      render();

      if (syncCheckbox !== false) {
        var checkbox = getCheckboxByProductId(productId);
        if (checkbox) checkbox.checked = false;
      }
    }

    function clearAll() {
      var productIds = items.map(function (item) {
        return item.productId;
      });

      items = [];
      render();

      productIds.forEach(function (productId) {
        var checkbox = getCheckboxByProductId(productId);
        if (checkbox) checkbox.checked = false;
      });
    }

    function hydrateFromCheckboxes() {
      var previousSelections = {};
      items.forEach(function (item) {
        previousSelections[String(item.productId)] = item.selectedVariantId;
      });

      items = [];

      document
        .querySelectorAll('.darche-compare-trigger input[type="checkbox"]:checked')
        .forEach(function (checkbox) {
          var trigger = checkbox.closest('.darche-compare-trigger');
          if (!trigger) return;

          var data = parseCompareData(trigger);
          var item = normalizeCompareItem(data);
          if (!item) {
            checkbox.checked = false;
            return;
          }

          if (findIndexByProductId(item.productId) !== -1) return;

          if (items.length >= MAX_COMPARE) {
            checkbox.checked = false;
            return;
          }

          var previousVariantId = previousSelections[String(item.productId)];
          if (previousVariantId != null) {
            item.selectedVariantId = previousVariantId;
          }

          items.push(item);
        });

      render();
    }

    function onTriggerChange(event) {
      var checkbox = event.target;
      if (!checkbox.matches('.darche-compare-trigger input[type="checkbox"]')) return;

      var trigger = checkbox.closest('.darche-compare-trigger');
      if (!trigger) return;

      var data = parseCompareData(trigger);
      if (!data) {
        checkbox.checked = false;
        return;
      }

      if (checkbox.checked) {
        var added = addItem(data);
        if (!added) {
          checkbox.checked = false;
        }
      } else {
        removeItem(data.productId, false);
      }
    }

    document.addEventListener('change', onTriggerChange);

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearAll();
      });
    }

    if (compareBtn) {
      compareBtn.addEventListener('click', function () {
        openModal();
      });
    }

    if (slotsEl) {
      slotsEl.addEventListener('click', function (event) {
        var removeBtn = event.target.closest('[data-compare-remove]');
        if (!removeBtn) return;
        removeItem(removeBtn.getAttribute('data-compare-remove'));
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-compare-modal-close]')) {
          closeModal();
        }
      });

      modal.addEventListener('change', function (event) {
        var select = event.target.closest('[data-compare-variant-select]');
        if (!select) return;

        setSelectedVariant(select.getAttribute('data-product-id'), select.value);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    window.addEventListener('pageshow', function () {
      // Form state restore can land after JS init; re-sync from checked boxes.
      requestAnimationFrame(hydrateFromCheckboxes);
    });

    hydrateFromCheckboxes();
  }

  function init() {
    var panel = document.querySelector('[data-compare-panel]');
    if (!panel) return;
    initComparePanel(panel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
